export const NotAuthorizedPage = () => {
  return (
    <div className="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-w-full tw-h-screen">
      <div>
        <h1 className="tw-text-[20rem] tw-font-semibold tw-text-primary-light-500">
          401
        </h1>
      </div>
      <div>
        <h4 className="tw-font-subtitle3 tw-mb-1">NOT AUTHORIZED</h4>
        <p>You {"don't"} have permissions to access to this page.</p>
      </div>
    </div>
  );
};
